const variables = {
  cv: 'https://drive.google.com/file/d/1pc5cSLZDC2PqRgPlAP2OcM-_Yq6Qi_H0/view?usp=sharing',
};

export default variables;
